import { __ } from '@wordpress/i18n';

// Friendly labels for the `region.keyword` facet, mirroring the "Region" ACF field in Jobs Settings (aq_jobs_region / aq_jobs_regions).
export const getRegionLabels = (): Record<string, string> => ({
  namerica: __('North America', 'wp-plugin-jobs'),
  australia: __('Australia', 'wp-plugin-jobs'),
  europe: __('Europe', 'wp-plugin-jobs'),
  japan: __('Japan', 'wp-plugin-jobs'),
});
